export default __webpack_public_path__ + "static/media/Logo_image_2020_08_09T19_10_38_409Z.1a462a42.png";